import { memo } from "react";

import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

import { QuestionSectionWrapper } from "../../../../../_shared/ui/components/system/question/_layouts/item-wrapper";

type Props = {
	isEdited: boolean;
	hasError: boolean;

	saleStartBeforeDate: ForNodeType<InputMaybe<number> | undefined> | undefined;
	onSetSaleStartBeforeDate: (input: number | undefined) => void;

	title?: string;
	guide?: string;
};

export const QuestionOptionSaleStartBeforeDate = memo(
	({
		isEdited,
		hasError,

		saleStartBeforeDate,
		onSetSaleStartBeforeDate,

		title: _title,
		guide: _guide,
	}: Props) => {
		const title = _title ?? "予約の開始可能日時";
		const guide =
			_guide ??
			"直前の予約のみを受け入れたい場合はここで直前予約可能な日を入力してください。<br />日ごとに選択可能なサービスの場合は、日ごとに購入可能な上限になります。<br />「お子様１人あたり」に設定すると、お子様のみが選択できるオプションを作成できます。";

		return (
			<FeatureIslandCategoryQuestionForMain
				required={false}
				title={title}
				guide={guide}
				isEdited={isEdited}
				hasError={hasError}
				inputChildren={
					<QuestionSectionWrapper>
						<p>チェックイン日の</p>

						<InputNumberField
							value={saleStartBeforeDate?.value ?? undefined}
							handleInput={onSetSaleStartBeforeDate}
							errorMessage={saleStartBeforeDate?.error}
							hiddenSpinButton={false}
						/>
						<p>日前から予約可能</p>
					</QuestionSectionWrapper>
				}
			/>
		);
	},
);

QuestionOptionSaleStartBeforeDate.displayName = "QuestionOptionSaleStartBeforeDate";
